import React from 'react'
import { ImageComponent } from '../Image/Image'

const FloatyImageMenu = ({
  positions,
  simulatedBox,
  updateImage
}) => {
  if (positions.top === null || positions.left === null) return null
  // Poser le panneau À CÔTÉ de l'image (à droite, sinon à gauche s'il n'y a pas
  // la place) plutôt que par-dessus : l'élément « Remarques » reste visible.
  const GAP = 8
  const PANEL_W = 280
  const placeLeft = window.innerWidth - positions.right < PANEL_W + GAP
  const left = placeLeft
    ? Math.max(GAP, positions.left - PANEL_W - GAP)
    : positions.right + GAP
  const top = Math.max(GAP, positions.top)
  return (
    <div style={{
      position: 'absolute',
      zIndex: 9998,
      boxSizing: 'border-box',
      background: '#FFFFFF',
      border: '1px solid rgba(11, 34, 57, 0.12)',
      boxShadow: '0 8px 24px rgba(11, 34, 57, 0.18)',
      padding: '12px 14px',
      borderRadius: 8,
      width: PANEL_W,
      maxHeight: '60vh',
      overflowY: 'auto',
      top,
      left
    }}
      onMouseDown={(e) => {
        e.stopPropagation()
      }}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <ImageComponent box={simulatedBox} updateImage={updateImage} inline />
    </div>
  )
}

export default FloatyImageMenu
